var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7DA0"
    },
    d: "M256.83,475.977c0,0-0.674-0.346-1.936-1.017c-1.262,0.671-1.936,1.017-1.936,1.017H256.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7DA0"
    },
    d: "M497.873,169.832h-0.02c0-73.787-52.952-136.481-126.489-136.285 c-51.629,0-96.048,30.815-115.846,75.035h-1.25c-19.798-44.22-64.217-75.035-115.845-75.035 C64.886,33.35,11.934,96.044,11.934,169.832h-0.02c0,171.35,220.037,292.918,242.98,305.128 C277.836,462.75,497.873,341.182,497.873,169.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB4B86"
    },
    d: "M376.979,170.429c-100.914,0-183.013,82.099-183.013,183.012 c0,39.418,12.526,75.965,33.807,105.869c13.439,8.236,23.182,13.553,27.12,15.649c20.997-11.174,207.071-113.946,238.482-262.644 C461.721,186.161,421.153,170.429,376.979,170.429z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -139.5062 370.0853)",
    style: {
      fill: "#B1D952"
    },
    cx: 376.979,
    cy: 353.442,
    rx: 123.013,
    ry: 123.013
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M471.294,274.464C488.216,240.298,500,200.647,500,160.259c0-69.982-56.792-126.713-126.847-126.713 c-53.908,0-99.955,33.595-118.322,80.968c-18.367-47.373-64.414-80.968-118.322-80.968C62.972,33.35,10.02,96.044,10.02,169.832 H10c0,180.774,244.916,306.145,244.916,306.145c0.685-0.102,12.456-4.762,45.019-26.641"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -139.5062 370.0853)",
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 376.979,
    cy: 353.442,
    rx: 123.013,
    ry: 123.013
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 329.002,355.448 359.649,386.095 424.957,320.788 \t\t"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.e098d1d5964c9bdbd4c8668b113b8719.svg";
export { ForwardRef as ReactComponent };